import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/global.css';
import './assets/styles/ansa-theme.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyMerdekaTheme } from './utils/merdeka-theme';

// Merdeka ke-69 campaign icons (Ansa-Support #54). No-op outside 27 Aug - 17 Sep 2026.
applyMerdekaTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
